import { memo } from 'react';

import { type ListSlackIntegrationsObject } from '@air/api/types';
import { Slack as SlackIcon } from '@air/next-icons';

import { displaySlackChannelName } from '../utils/displaySlackChannelName';

type ConnectedSlackChannelProps = {
  channelName: string;
  integration: ListSlackIntegrationsObject;
};

export const ConnectedSlackChannel = memo(({ channelName, integration }: ConnectedSlackChannelProps) => {
  return (
    <div className="flex h-12 flex-col justify-center border-0 bg-grey-3 text-grey-11">
      <div className="flex items-center">
        <SlackIcon className="mt-0.5 mr-1 size-4" />
        <div className="font-medium text-14 text-inherit">{displaySlackChannelName(channelName)}</div>
      </div>
      <div className="ml-5 font-normal text-12 text-grey-10">
        {integration.isCoveredByAncestor ? 'via parent board ' : ''}
      </div>
    </div>
  );
});

ConnectedSlackChannel.displayName = 'ConnectedSlackChannel';
